module.exports = __webpack_public_path__ + "img/dataDetailExample.296decac.png";